import { combineReducers } from 'redux';

import team from './team';

export default combineReducers({
  team,
});